import React, { useState } from "react"
import styled from "styled-components"

const Button = styled.button`
	position: relative;
	height: 40px;
	width: 160px;
	svg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		transition: opacity 0.25s ease-in-out;
	}
	.noHover {
		opacity: ${props => (props.hover ? "0" : "1")};
	}
	.hover {
		opacity: ${props => (props.hover ? "1" : "0")};
	}
`

const FilmButton = props => {
	const [hover, setHover] = useState(false)
	return (
		<Button
			{...props}
			hover={hover}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
		>
			<svg
				width="160px"
				height="40px"
				viewBox="0 0 160 40"
				version="1.1"
				className="noHover"
			>
				<g
					id="Desktop"
					stroke="none"
					strokeWidth="1"
					fill="none"
					fillRule="evenodd"
				>
					<g
						id="1WSQ-Desktop-Home-Landing"
						transform="translate(-760.000000, -546.000000)"
						fill="#FFFFFF"
						fillRule="nonzero"
					>
						<g
							id="film-CTA"
							transform="translate(760.000000, 546.000000)"
						>
							<path
								d="M160,0 L160,40 L0,40 L0,0 L160,0 Z M38,2 L2,2 L2,38 L38,38 L38,2 Z M158,2 L40,2 L40,38 L158,38 L158,2 Z M80.3503395,13.22 C81.9753395,13.22 83.0045062,13.9783333 83.582284,14.4838889 L83.582284,14.4838889 L82.8961728,15.2783333 C82.1558951,14.6283333 81.4336728,14.2491667 80.3864506,14.2491667 C78.9781173,14.2491667 77.8406173,15.1158333 77.8406173,16.4880556 C77.8406173,18.4019444 80.3864506,18.6547222 82.1920062,19.7741667 C83.2392284,20.4241667 84.1058951,21.3630556 84.1058951,22.8255556 C84.1058951,24.8297222 82.4808951,26.22 80.4225617,26.22 C78.7433951,26.22 77.3170062,25.5158333 76.2336728,24.0894444 L76.2336728,24.0894444 L77.0281173,23.3852778 C77.7683951,24.3422222 78.7614506,25.1908333 80.4225617,25.1908333 C81.6864506,25.1908333 83.0225617,24.2880556 83.0225617,22.8255556 C83.0225617,20.5325 80.3142284,20.2797222 78.4725617,19.1422222 C77.5336728,18.5644444 76.757284,17.8241667 76.757284,16.5422222 C76.757284,14.5741667 78.3281173,13.22 80.3503395,13.22 Z M93.0173148,13.22 C96.5923148,13.22 99.3006481,16.0366667 99.3006481,19.72 C99.3006481,21.3811111 98.7409259,22.8797222 97.802037,24.0172222 L97.802037,24.0172222 L99.6617593,26.0394444 L98.289537,26.0394444 L97.0978704,24.7213889 C96.014537,25.6602778 94.6062037,26.22 93.0173148,26.22 C89.4423148,26.22 86.7339815,23.4033333 86.7339815,19.72 C86.7339815,16.0366667 89.4423148,13.22 93.0173148,13.22 Z M54.5108333,13.4005556 L54.5108333,26.0394444 L53.4275,26.0394444 L53.4275,14.8269444 L50.99,16.1811111 L50.99,15.0977778 L53.7886111,13.4005556 L54.5108333,13.4005556 Z M59.1430864,13.4005556 L62.5375309,23.8547222 L65.9139198,13.4005556 L66.636142,13.4005556 L70.0125309,23.8547222 L73.4069753,13.4005556 L74.5083642,13.4005556 L70.3555864,26.0394444 L69.6333642,26.0394444 L66.2750309,15.6575 L62.9166975,26.0394444 L62.1944753,26.0394444 L58.0416975,13.4005556 L59.1430864,13.4005556 Z M115.390154,13.4005556 L115.390154,14.4297222 L109.612377,14.4297222 L109.612377,18.5463889 L114.126265,18.5463889 L114.126265,19.5755556 L109.612377,19.5755556 L109.612377,26.0394444 L108.529043,26.0394444 L108.529043,13.4005556 L115.390154,13.4005556 Z M119.462685,13.4005556 L119.462685,26.0394444 L118.379352,26.0394444 L118.379352,13.4005556 L119.462685,13.4005556 Z M124.799105,13.4005556 L124.799105,25.0102778 L130.757438,25.0102778 L130.757438,26.0394444 L123.715772,26.0394444 L123.715772,13.4005556 L124.799105,13.4005556 Z M134.468858,13.4005556 L139.650802,22.0852778 L144.832747,13.4005556 L145.554969,13.4005556 L145.554969,26.0394444 L144.471636,26.0394444 L144.471636,16.0366667 L140.011914,23.5116667 L139.289691,23.5116667 L134.829969,16.0366667 L134.829969,26.0394444 L133.746636,26.0394444 L133.746636,13.4005556 L134.468858,13.4005556 Z M15,14 L27,20 L15,26 L15,14 Z M93.0173148,14.2491667 C89.9659259,14.2491667 87.8173148,16.7227778 87.8173148,19.72 C87.8173148,22.7172222 89.9659259,25.1908333 93.0173148,25.1908333 C94.3534259,25.1908333 95.5089815,24.7213889 96.3937037,23.945 L96.3937037,23.945 L93.1617593,20.37 L93.902037,19.72 L97.0798148,23.2047222 C97.802037,22.2658333 98.2173148,21.0380556 98.2173148,19.72 C98.2173148,16.7227778 96.0687037,14.2491667 93.0173148,14.2491667 Z"
								id="icon-full-play"
							></path>
						</g>
					</g>
				</g>
			</svg>
			<svg
				width="160px"
				height="40px"
				viewBox="0 0 160 40"
				version="1.1"
				className="hover"
			>
				<g
					id="Desktop"
					stroke="none"
					strokeWidth="1"
					fill="none"
					fillRule="evenodd"
				>
					<g
						id="1WSQ-Desktop-Home-Landing"
						transform="translate(-760.000000, -546.000000)"
						fill="#FFFFFF"
						fillRule="nonzero"
					>
						<g
							id="film-CTA"
							transform="translate(760.000000, 546.000000)"
						>
							<path
								d="M160,0 L160,40 L0,40 L0,0 L160,0 Z M158,2 L40,2 L40,38 L158,38 L158,2 Z M80.3503395,13.22 C81.9753395,13.22 83.0045062,13.9783333 83.582284,14.4838889 L83.582284,14.4838889 L82.8961728,15.2783333 C82.1558951,14.6283333 81.4336728,14.2491667 80.3864506,14.2491667 C78.9781173,14.2491667 77.8406173,15.1158333 77.8406173,16.4880556 C77.8406173,18.4019444 80.3864506,18.6547222 82.1920062,19.7741667 C83.2392284,20.4241667 84.1058951,21.3630556 84.1058951,22.8255556 C84.1058951,24.8297222 82.4808951,26.22 80.4225617,26.22 C78.7433951,26.22 77.3170062,25.5158333 76.2336728,24.0894444 L76.2336728,24.0894444 L77.0281173,23.3852778 C77.7683951,24.3422222 78.7614506,25.1908333 80.4225617,25.1908333 C81.6864506,25.1908333 83.0225617,24.2880556 83.0225617,22.8255556 C83.0225617,20.5325 80.3142284,20.2797222 78.4725617,19.1422222 C77.5336728,18.5644444 76.757284,17.8241667 76.757284,16.5422222 C76.757284,14.5741667 78.3281173,13.22 80.3503395,13.22 Z M93.0173148,13.22 C96.5923148,13.22 99.3006481,16.0366667 99.3006481,19.72 C99.3006481,21.3811111 98.7409259,22.8797222 97.802037,24.0172222 L97.802037,24.0172222 L99.6617593,26.0394444 L98.289537,26.0394444 L97.0978704,24.7213889 C96.014537,25.6602778 94.6062037,26.22 93.0173148,26.22 C89.4423148,26.22 86.7339815,23.4033333 86.7339815,19.72 C86.7339815,16.0366667 89.4423148,13.22 93.0173148,13.22 Z M54.5108333,13.4005556 L54.5108333,26.0394444 L53.4275,26.0394444 L53.4275,14.8269444 L50.99,16.1811111 L50.99,15.0977778 L53.7886111,13.4005556 L54.5108333,13.4005556 Z M59.1430864,13.4005556 L62.5375309,23.8547222 L65.9139198,13.4005556 L66.636142,13.4005556 L70.0125309,23.8547222 L73.4069753,13.4005556 L74.5083642,13.4005556 L70.3555864,26.0394444 L69.6333642,26.0394444 L66.2750309,15.6575 L62.9166975,26.0394444 L62.1944753,26.0394444 L58.0416975,13.4005556 L59.1430864,13.4005556 Z M115.390154,13.4005556 L115.390154,14.4297222 L109.612377,14.4297222 L109.612377,18.5463889 L114.126265,18.5463889 L114.126265,19.5755556 L109.612377,19.5755556 L109.612377,26.0394444 L108.529043,26.0394444 L108.529043,13.4005556 L115.390154,13.4005556 Z M119.462685,13.4005556 L119.462685,26.0394444 L118.379352,26.0394444 L118.379352,13.4005556 L119.462685,13.4005556 Z M124.799105,13.4005556 L124.799105,25.0102778 L130.757438,25.0102778 L130.757438,26.0394444 L123.715772,26.0394444 L123.715772,13.4005556 L124.799105,13.4005556 Z M134.468858,13.4005556 L139.650802,22.0852778 L144.832747,13.4005556 L145.554969,13.4005556 L145.554969,26.0394444 L144.471636,26.0394444 L144.471636,16.0366667 L140.011914,23.5116667 L139.289691,23.5116667 L134.829969,16.0366667 L134.829969,26.0394444 L133.746636,26.0394444 L133.746636,13.4005556 L134.468858,13.4005556 Z M15,14 L15,26 L27,20 L15,14 Z M93.0173148,14.2491667 C89.9659259,14.2491667 87.8173148,16.7227778 87.8173148,19.72 C87.8173148,22.7172222 89.9659259,25.1908333 93.0173148,25.1908333 C94.3534259,25.1908333 95.5089815,24.7213889 96.3937037,23.945 L96.3937037,23.945 L93.1617593,20.37 L93.902037,19.72 L97.0798148,23.2047222 C97.802037,22.2658333 98.2173148,21.0380556 98.2173148,19.72 C98.2173148,16.7227778 96.0687037,14.2491667 93.0173148,14.2491667 Z"
								id="icon-play-full-hover"
							></path>
						</g>
					</g>
				</g>
			</svg>
		</Button>
	)
}

export default FilmButton
